import noop from 'lib/function/noop'
import GlobalSearchQuickFilterLoadingButtons from '../GlobalSearch/QuickFilters/GlobalSearchQuickFilterLoadingButtons'
import PopularDestinationButton from './PopularDestinationButton'
import type { Option } from './PopularDestinationButton'

interface Props {
  onClickHandler?: (option: Option) => void
  onContextMenuHandler?: (option: Option) => void
  onImpressionHandler?: (option: Option) => void
  options: Array<Option>
  fetching: boolean
}

function PopularButtonList({
  onClickHandler,
  onContextMenuHandler,
  options,
  fetching,
}: Props) {
  if (!fetching && !options.length) {
    return null
  }

  return (
    <>
      {fetching && <GlobalSearchQuickFilterLoadingButtons />}
      {!fetching && options.map(option => {
        return <PopularDestinationButton
          key={option.value}
          option={option}
          onClickHandler={onClickHandler}
          onContextMenuHandler={onContextMenuHandler}
        />
      })}
    </>
  )
}

PopularButtonList.defaultTypes = {
  onContextMenuHandler: noop,
}

export default PopularButtonList
